import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import { Form, Formik } from 'formik'
import axiosService from '../../../utils/AxiosService';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import { toastError, toastSuccess } from '../../FormComponents/Toasts';
import Input from '../../FormComponents/Input'
import { NewPasswordProjectManagerSchema } from '../../../schemas/ProjectManager/NewPasswordProjectManagerSchema'

const PasswordResetForm = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const togglePasswordVisibility = (setVisibility) => {
    setVisibility(prevState => !prevState)
  }

  const handlePasswordUpdate = (values) => {
    axiosService.patch('/api/project_manager/password/reset', { 
      password: {
        new_password: values.new_password,
        new_password_confirmation: values.new_password_confirmation
      }
    })
      .then(({ message }) => {
        navigate('/')
        toastSuccess(message)
      })
      .catch(({data: { error }}) => {
        console.log(error)
        toastError(error)
    })
  }

  return (
    <>
      <div>
        <h2 className='font-bold text-xl'>Set your new password</h2>
        <p className='text-sm text-rb-mat-grey'>Please create a password that is at least 8 characters long, includes a number, and a special character (e.g., !, @, #, $).</p>
        <button
          className='text-rb-green text-sm mt-9 text-right w-full'
          onClick={() => navigate('/project_manager/campaigns')}
        >
          skip for now...
        </button>
      </div>
      <Formik
        initialValues={{
          new_password: '',
          new_password_confirmation: ''
        }}
        validationSchema={NewPasswordProjectManagerSchema}
        onSubmit={handlePasswordUpdate}
      >
        {({ errors, touched, handleBlur, handleChange, values }) => (
          <Form>
            <div className="relative">
              <Input
                error={touched.new_password && errors.new_password}
                label="New Password"
                name="new_password"
                noLabelPadding
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="New Password"
                value={values.new_password}
                type={showNewPassword ? 'text': 'password'}
              />
              <button
                onClick={() => togglePasswordVisibility(setShowNewPassword)}
                className="absolute right-4 top-11"
                type="button"
              >
                {showNewPassword ? <EyeSlash />: <Eye />}
              </button>
            </div>
            <div className="relative">
              <Input
                error={touched.new_password_confirmation && errors.new_password_confirmation}
                label="New Password Confrimation"
                name="new_password_confirmation"
                noLabelPadding
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="New Password Confirmation"
                value={values.new_password_confirmation}
                type={showConfirmPassword ? 'text': 'password'}
              />
              <button
                onClick={() => togglePasswordVisibility(setShowConfirmPassword)}
                className="absolute right-4 top-11"
                type="button"
              >
                {showConfirmPassword ? <EyeSlash />: <Eye />}
              </button>
            </div>
            <button
              type="submit"
              className="submit w-full text-white bg-rb-green rounded-lg py-2 text-center active:shadow mt-5"
            >
              Confirm change
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default PasswordResetForm;
